/* eslint-disable arrow-body-style */
import React, { useState, useEffect } from "react";
import { Button, Form, Header, Grid, Label, Icon, Dropdown, Checkbox } from "semantic-ui-react";
import Joi from "joi";
import PropTypes from "prop-types";
import { isEmpty, map, isEqual, trim, sortBy, get, reduce } from "lodash";

import { isValidPhoneNumber, parsePhoneNumber } from "libphonenumber-js";
import Text from "@Components/Text";

// Components
import MenuSelect from "@Components/MenuSelect";
import Input from "@Components/Input";
import IKModal from "@Components/IkModal";

// Modals
import ConfirmModal from "@Modals/ConfirmModal";

// redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";
import { displayNotification } from "@Actions/notifications";

// Utils
import { phoneFormat } from "@Utils/formats";
// import translateActionChat from "../../staticData";

// Styles
import styles from "./styles.module.css";

const MtnUserCrud = ({
	modalCrud,
	tableValue,
	onClose,
	perfilesList,
	groupsData,
	menuData,
	dispatch,
	apiData,
	userPermissions,
	endChatNoResponse,
	sendFlowEnabled,
	userRole,
}) => {
	const schema = Joi.object().keys({
		fullName: Joi.string().min(6).messages({
			"string.min": "Nombre debe tener mínimo 6 caracteres",
			"string.empty": "Nombre completo es un campo requerido",
		}),
		nickName: Joi.string().min(6).messages({
			"string.min": "Nombre de usuario debe tener mínimo 6 caracteres",
			"string.empty": "Nombre de usuario es un campo requerido",
		}),
		email: Joi.string()

			.email({ tlds: { allow: false } })
			.messages({
				"string.email": "Correo no valido",
				"string.empty": "Correo es un campo requerido",
			}),
		phone: Joi.string()
			.custom((value) => {
				if (!isValidPhoneNumber(value, "DO")) {
					throw new Error("");
				}
				if (isEmpty(value)) return value;
				return parsePhoneNumber(value, "DO").nationalNumber;
			}, "libphonenumber validation")
			.messages({
				"any.custom": "El teléfono no es valido",
				"string.empty": "Teléfono es un campo requerido",
			}),
		checkMenus: Joi.array().min(1).messages({
			"array.min": "Menú es un campo requerido",
		}),
		userGroups: Joi.array().min(1).messages({
			"array.min": "Debes agregar un Grupo",
		}),
		password: Joi.string().min(4).messages({
			"string.min": "Contraseña debe tener mínimo 4 caracteres",
			"string.empty": "Contraseña es un campo requerido",
		}),
		roleErr: Joi.string().messages({
			"string.empty": "Rol es un campo requerido",
			"string.base": "Rol es un campo requerido",
		}),
		defaultMenu: Joi.number().allow(null).messages({
			"number.base": "Default Menú debe ser un número válido",
		}),
		perfil: Joi.object().required().messages({
			"object.base": "Perfil es un campo requerido",
			"any.required": "Perfil es un campo requerido",
		}),
	});
	const [open, setOpen] = useState(false);
	const [showPassword, setShowPassword] = useState(false);

	const [groupData, setGroupData] = useState([]);
	const [perfilData, setPerfilData] = useState([]);
	const [stateHeader, setStateHeader] = useState("basicInfo");
	const [copied, setCopied] = useState(false);
	const [groupsAll, setGroupsAll] = useState(false);

	const [errors, setErrors] = useState({
		fullName: "",
		nickName: "",
		email: "",
		phone: "",
		roleErr: "",
		userGroups: "",
		checkMenus: "",
		password: "",
		defaultMenu: "",
		perfil: "",
	});
	const [initialFormData, setInitialFormData] = useState([]);
	const [modalOption, setModalOption] = useState("");
	const [showProfileConfirmModal, setShowProfileConfirmModal] = useState(false);
	const [pendingProfile, setPendingProfile] = useState(null);
	const [pendingProfileFieldName, setPendingProfileFieldName] = useState("");
	// const [groups, setGroups] = useState([]);
	const [formData, setFormData] = useState({
		isActive: true,
		fullName: "",
		checkMenus: [],
		nickName: "",
		email: "",
		pin: "",
		phone: "",
		password: "",
		permissions: [],
		userGroups: [],
		perfil: [],
		user: "",
		role: "",
		defaultMenu: null,
	});

	useEffect(() => {
		const fetchData = async () => {
			const typesResponse = await dispatch(genericAction({ method: "get", route: "types/groups" }));

			if (!isEmpty(groupsData)) {
				setGroupData(
					map(groupsData, (item) => {
						const type = typesResponse.find((g) => g.id === item.typeId);
						return {
							key: item.id,
							text: `${type ? type.name : "Sin Tipo"} - ${item.name}`,
							value: item.id,
						};
					})
				);
			}
		};

		fetchData();
		setModalOption(modalCrud);

		if (!isEmpty(tableValue)) {
			const groupsId = map(get(tableValue, "groups", []), (item) => item.id);
			let perfilSelect = [];
			const currentRole = get(tableValue, "role", "");
			const formLiest = map(perfilesList, (item, index) => {
				if (!isEmpty(currentRole) && item.name === currentRole) {
					perfilSelect = item;
				}
				return { key: index + 1, text: item.name, value: item };
			});
			setPerfilData(formLiest);

			const menuFromTable = get(tableValue, "menu", []);
			const defaultMenuFromTable = get(tableValue, "defaultMenu.id", null);

			let finalDefaultMenu = defaultMenuFromTable;
			if (menuFromTable && menuFromTable.length > 0) {
				if (!defaultMenuFromTable || !menuFromTable.includes(defaultMenuFromTable)) {
					[finalDefaultMenu] = menuFromTable;
				}
			} else {
				finalDefaultMenu = null;
			}

			setInitialFormData({
				perfil: perfilSelect,
				isActive: get(tableValue, "isActive", true),
				checkMenus: menuFromTable,
				fullName: get(tableValue, "user.fullName", ""),
				role: get(tableValue, "role", ""),
				nickName: get(tableValue, "user.nickName", ""),
				password: get(tableValue, "user.password", ""),
				email: get(tableValue, "user.email", ""),
				pin: get(tableValue, "user.pin", ""),
				phone: get(tableValue, "user.phone", ""),
				permissions: sendFlowEnabled
					? {
							...get(tableValue, "permissions", []),
							allowSendFlow: get(tableValue, "permissions.allowSendFlow", false),
							allowConfigFlow: get(tableValue, "permissions.allowConfigFlow", false),
					  }
					: get(tableValue, "permissions", []),
				userGroups: groupsId,
				user: get(tableValue, "user", ""),
				defaultMenu: finalDefaultMenu,
			});
			setFormData({
				perfil: perfilSelect,
				isActive: get(tableValue, "isActive", true),
				checkMenus: menuFromTable,
				fullName: get(tableValue, "user.fullName", ""),
				role: get(tableValue, "role", ""),
				nickName: get(tableValue, "user.nickName", ""),
				password: get(tableValue, "user.password", ""),
				email: get(tableValue, "user.email", ""),
				pin: get(tableValue, "user.pin", ""),
				phone: get(tableValue, "user.phone", ""),
				permissions: sendFlowEnabled
					? {
							...get(tableValue, "permissions", []),
							allowSendFlow: get(tableValue, "permissions.allowSendFlow", false),
							allowConfigFlow: get(tableValue, "permissions.allowConfigFlow", false),
					  }
					: get(tableValue, "permissions", []),
				userGroups: groupsId,
				user: get(tableValue, "user", ""),
				defaultMenu: finalDefaultMenu,
			});
			const isAllSelected = groupData.length > 0 && groupData.length === groupsId.length;
			setGroupsAll(isAllSelected);
		} else {
			const formLiest = map(perfilesList, (item, index) => {
				return { key: index + 1, text: item.name, value: item };
			});
			setPerfilData(formLiest);

			const defaultTrueKeys = ["allowTransferChat", "allowTakeChat", "allowFreeChat", "allowEndChat"];

			const filteredPermissions = reduce(
				userPermissions,
				(acc, _value, key) => {
					acc[key] = defaultTrueKeys.includes(key);
					return acc;
				},
				{}
			);

			if (sendFlowEnabled && !("allowSendFlow" in filteredPermissions)) {
				filteredPermissions.allowSendFlow = false;
			}
			if (sendFlowEnabled && !("allowConfigFlow" in filteredPermissions)) {
				filteredPermissions.allowConfigFlow = false;
			}

			setInitialFormData({
				...formData,
				permissions: filteredPermissions,
			});
			setFormData({
				...formData,
				permissions: filteredPermissions,
			});

			setGroupsAll(false);
		}
	}, [tableValue]);

	useEffect(() => {
		if (groupData.length > 0 && formData.userGroups.length > 0) {
			const isAllSelected = groupData.length === formData.userGroups.length;
			setGroupsAll(isAllSelected);
		}
	}, [groupData, formData.userGroups]);

	// handle save
	const handlerSaved = async () => {
		let validationObj = {
			userGroups: formData.userGroups,
			fullName: formData.fullName,
			email: formData.email,
			checkMenus: formData.checkMenus,
			phone: formData.phone,
			roleErr: formData.role,
			nickName: formData.nickName,
			perfil: formData.perfil,
		};

		if (modalOption === "Add") {
			validationObj = {
				...validationObj,
				password: formData.password,
				email: formData.email,
				phone: formData.phone,
			};
		}

		const validation = schema.validate(validationObj, { abortEarly: false });

		if (validation.error) {
			const { details } = validation.error;
			let errorsVal = {
				userGroups: "",
				fullName: "",
				nickName: "",
				checkMenus: [],
				email: "",
				phone: "",
				roleErr: "",
				perfil: "",
				password: "",
			};
			map(details, (item) => {
				errorsVal = { ...errorsVal, [item.context.key]: item.message };
			});
			setErrors(errorsVal);
		} else {
			let dataEditor = {
				fullName: trim(formData.fullName),
				role: formData.role,
				menu: formData.checkMenus,
				email: trim(formData.email),
				phone: formData.phone,
				permissions: formData.permissions,
				groupsIdList: formData.userGroups,
				isActive: formData.isActive,
				nickName: trim(formData.nickName),
				pin: formData.pin,
				defaultMenuId: formData.defaultMenu,
				perfil: formData.perfil,
			};

			if (modalOption === "Add") {
				dataEditor = {
					...dataEditor,
					password: formData.password,
					email: formData.email,
					phone: formData.phone,
				};

				const dataAdd = await dispatch(genericAction({ method: "post", route: `users`, body: dataEditor }));

				if (!isEmpty(dataAdd)) {
					const resetForm = {
						isActive: true,
						fullName: "",
						role: "",
						checkMenus: [],
						email: "",
						phone: "",
						pin: "",
						nickName: "",
						password: "",
						permissions: userPermissions,
						userGroups: [],
						user: "",
						defaultMenu: null,
						perfil: "",
					};

					setFormData(resetForm);
					setInitialFormData(resetForm);
					apiData("Add", dataAdd);
				}
			} else {
				const changedData = {};

				if (trim(formData.fullName) !== trim(initialFormData.fullName)) {
					changedData.fullName = trim(formData.fullName);
				}
				if (trim(formData.nickName) !== trim(initialFormData.nickName)) {
					changedData.nickName = trim(formData.nickName);
				}
				if (formData.role !== initialFormData.role) {
					changedData.role = formData.role;
				}
				if (!isEqual(sortBy(formData.checkMenus), sortBy(initialFormData.checkMenus))) {
					changedData.menu = formData.checkMenus;
				}
				if (trim(formData.email) !== trim(initialFormData.email)) {
					changedData.email = trim(formData.email);
				}
				if (formData.phone !== initialFormData.phone) {
					changedData.phone = formData.phone;
				}
				if (!isEqual(formData.permissions, initialFormData.permissions)) {
					changedData.permissions = formData.permissions;
				}
				if (!isEqual(sortBy(formData.userGroups), sortBy(initialFormData.userGroups))) {
					const groupsId = map(tableValue.groups, (item) => {
						return item.id;
					});
					changedData.groupsIdList = formData.userGroups;
					changedData.prevGroupsIdList = groupsId;
				}
				if (formData.isActive !== initialFormData.isActive) {
					changedData.isActive = formData.isActive;
				}
				const currentNickName = trim(formData.nickName) === "" ? "" : trim(formData.nickName);
				const initialNickName = trim(initialFormData.nickName) === "" ? "" : trim(initialFormData.nickName);
				if (currentNickName !== initialNickName) {
					changedData.nickName = currentNickName;
				}
				if (formData.pin !== initialFormData.pin) {
					changedData.pin = formData.pin;
				}
				if (formData.defaultMenu !== initialFormData.defaultMenu) {
					changedData.defaultMenuId = formData.defaultMenu;
				}
				const dataEdit = await dispatch(genericAction({ method: "patch", route: `users/${tableValue.userId}`, body: changedData }));

				if (!isEmpty(dataEdit)) {
					setInitialFormData(formData);
					apiData("Edit");
				}
			}

			setErrors({
				fullName: "",
				email: "",
				phone: "",
				checkMenus: "",
				nickName: "",
				roleErr: "",
				userGroups: "",
				password: "",
				perfil: "",
				defaultMenu: "",
			});
		}
	};

	// modal
	const cancelModal = () => {
		onClose();
	};
	const modalOpen = () => {
		if (isEqual(initialFormData, formData)) {
			cancelModal();
		} else if (open) {
			setOpen(false);
		} else {
			setOpen(true);
		}
	};

	const handleInputDropdown = (event, { name, value }) => {
		setFormData((prevState) => {
			return {
				...prevState,
				[name]: value,
			};
		});

		if (name === "userGroups") {
			const isAllSelected = groupData.length > 0 && groupData.length === value.length;
			setGroupsAll(isAllSelected);
		}
	};

	const handlePerfilDropdown = (event, { name, value }) => {
		if (!value) {
			const defaultTrueKeys = ["allowTransferChat", "allowTakeChat", "allowFreeChat", "allowEndChat"];
			const permissionsByDefault = reduce(
				userPermissions,
				(acc, _value, key) => {
					acc[key] = defaultTrueKeys.includes(key);
					return acc;
				},
				{}
			);

			if (sendFlowEnabled && !("allowSendFlow" in permissionsByDefault)) {
				permissionsByDefault.allowSendFlow = false;
			}
			if (sendFlowEnabled && !("allowConfigFlow" in permissionsByDefault)) {
				permissionsByDefault.allowConfigFlow = false;
			}

			setFormData({
				...formData,
				checkMenus: [],
				permissions: permissionsByDefault,
				role: "",
				defaultMenu: null,
				[name]: null,
			});
			return;
		}

		setPendingProfile(value);
		setPendingProfileFieldName(name);
		setShowProfileConfirmModal(true);
	};

	const handleApplyNewProfile = () => {
		const profile = pendingProfile;
		const name = pendingProfileFieldName;

		let newPermissions = profile.permissions || {};
		if (typeof newPermissions === "string") {
			try {
				newPermissions = JSON.parse(newPermissions);
			} catch (e) {
				newPermissions = {};
			}
		}

		const defaultPermissions = reduce(
			userPermissions,
			(acc, _value, key) => {
				acc[key] = false;
				return acc;
			},
			{}
		);

		setFormData({
			...formData,
			checkMenus: get(profile, "menu", []),
			permissions: { ...defaultPermissions, ...newPermissions },
			role: profile.name,
			defaultMenu: get(profile, "defaultMenu.id", null),
			[name]: profile,
		});

		setShowProfileConfirmModal(false);
		setPendingProfile(null);
		setPendingProfileFieldName("");
	};

	const handleKeepCurrentProfile = () => {
		const profile = pendingProfile;
		const name = pendingProfileFieldName;

		setFormData({
			...formData,
			role: profile.name,
			[name]: profile,
		});

		setShowProfileConfirmModal(false);
		setPendingProfile(null);
		setPendingProfileFieldName("");
	};

	const handleCancelProfileChange = () => {
		setShowProfileConfirmModal(false);
		setPendingProfile(null);
		setPendingProfileFieldName("");
	};

	const handlerInput = (event) => {
		const { name, value } = event.target;

		setFormData({
			...formData,
			[name]: value,
		});
	};
	const handlerMenu = (value) => {
		let newDefaultMenu = formData.defaultMenu;
		if (value && value.length > 0) {
			if (!newDefaultMenu || !value.includes(newDefaultMenu)) {
				[newDefaultMenu] = value;
			}
		} else {
			newDefaultMenu = null;
		}

		setFormData({
			...formData,
			checkMenus: value,
			defaultMenu: newDefaultMenu,
		});
	};
	const handleCheckAct = (key, value) => {
		setFormData({
			...formData,
			[value.name]: value.checked,
		});
	};
	const onChangePermissions = (e, data) => {
		const { name, checked } = data;

		setFormData({
			...formData,
			permissions: {
				...formData.permissions,
				[name]: checked,
			},
		});
	};

	const handlerChangePin = async () => {
		const pinData = await dispatch(genericAction({ method: "get", route: `/user/generatePin` }));

		setFormData({
			...formData,
			pin: pinData,
		});
	};

	const handleCopyPin = () => {
		if (formData.pin) {
			navigator.clipboard.writeText(formData.pin).then(() => {
				setCopied(true);
				setTimeout(() => {
					return setCopied(false);
				}, 1500);
			});
		}
	};

	const handleStateHeader = (states) => {
		return setStateHeader(states);
	};

	const checkAll = (name) => {
		switch (name) {
			case "groupsfilters":
				if (!groupsAll) {
					const groupArray = map(groupData, (item) => {
						return item.value;
					});
					setFormData((prev) => {
						return {
							...prev,
							userGroups: groupArray,
						};
					});
					setGroupsAll(true);
				} else {
					setFormData((prev) => {
						return {
							...prev,
							userGroups: [],
						};
					});
					setGroupsAll(false);
				}
				break;
			default:
				break;
		}
	};

	const menuOptions = [];

	if (menuData && formData.checkMenus) {
		menuData.forEach((menuItem) => {
			if (formData.checkMenus.includes(menuItem.id)) {
				menuOptions.push({
					key: menuItem.id,
					text: menuItem.name,
					value: menuItem.id,
				});

				if (menuItem.subMenu && menuItem.subMenu.length > 0) {
					menuItem.subMenu.forEach((subMenuItem) => {
						if (formData.checkMenus.includes(subMenuItem.id)) {
							menuOptions.push({
								key: subMenuItem.id,
								text: `${menuItem.name} > ${subMenuItem.name}`,
								value: subMenuItem.id,
							});
						}
					});
				}
			}
		});
	}

	const handleFreeAllChats = async () => {
		try {
			await dispatch(genericAction({ method: "POST", route: `chats/freeChat/all/${tableValue.userId}` }));
			dispatch(displayNotification({ text: "Se liberaron todos los chats del usuario.", isError: false }));
		} catch (error) {
			dispatch(displayNotification({ text: "Error al liberar chats.", isError: true }));
		}
	};

	const footerButtons =
		modalOption !== "Add" && userRole && userRole.toLowerCase() === "master"
			? [
					<Button key="free-all" className={`${styles.negativeButton} ${styles.freeAllButton}`} onClick={handleFreeAllChats}>
						Liberar todas
					</Button>,
			  ]
			: [];

	return (
		<>
			<IKModal
				title={modalOption === "Add" ? "Agregar Usuarios" : `Usuario: ${get(tableValue, "user.fullName", "")} `}
				id={tableValue.userId}
				mode={modalOption}
				setMode={setModalOption}
				onClose={modalOpen}
				onSuccess={handlerSaved}
				saveDisabled={isEqual(initialFormData, formData)}
				size="small"
				footerButtons={footerButtons}
				fullHeight>
				<div className={styles.megaContent}>
					<div className={styles.divHeaderNav}>
						<div className={styles.classButtonHeader}>
							<div className={styles.basicInfo}>
								<Button
									className={stateHeader === "basicInfo" ? `${styles.navButton} ${styles.active}` : styles.navButton}
									onClick={() => {
										handleStateHeader("basicInfo");
									}}>
									Información Básica
								</Button>
							</div>
							<div className={styles.divButtonPermissions}>
								<Button
									className={stateHeader === "permissions" ? `${styles.navButton} ${styles.active}` : styles.navButton}
									disabled={isEmpty(formData.perfil)}
									onClick={() => {
										handleStateHeader("permissions");
									}}>
									Permisos
								</Button>
							</div>
						</div>
					</div>

					<div className={styles.grid}>
						{stateHeader === "basicInfo" && (
							<Grid columns={1} className={styles.grid}>
								<Grid.Row className={styles.grid}>
									<Grid.Column width={16} className={styles.grid}>
										<div className={styles.containerInfor}>
											<Form autoComplete="off">
												<Grid columns={3} stackable verticalAlign="middle">
													<Grid.Row className={styles.grid}>
														<Grid.Column className={styles.columnClass}>
															<Text className={styles.textClass}>Activo</Text>
															<Form.Checkbox
																toggle
																label={formData.isActive ? "Sí" : "No"}
																name="isActive"
																disabled={modalOption === "Watch"}
																checked={formData.isActive}
																onChange={handleCheckAct}
															/>
														</Grid.Column>
														<Grid.Column className={styles.columnClass}>
															<div className={styles.inputContainer}>
																<Form.Input
																	label="Pin:"
																	disabled
																	value={formData.pin}
																	type={showPassword ? "text" : "password"}
																	className={styles.classPin}
																/>
																{formData.pin && (
																	<Button
																		size="mini"
																		icon={showPassword ? "eye slash" : "eye"}
																		onClick={(e) => {
																			e.preventDefault();
																			setShowPassword(!showPassword);
																		}}
																		compact
																		className={styles.showButton}
																	/>
																)}
																<Button
																	disabled={modalOption === "Watch"}
																	size="mini"
																	icon="exchange"
																	onClick={(e) => {
																		e.preventDefault();
																		handlerChangePin();
																	}}
																	compact
																	className={styles.changeButton}
																/>
																{formData.pin && (
																	<div className={styles.copyContainer}>
																		<Icon name="copy outline" size="big" className={styles.icon} onClick={handleCopyPin} />
																		{copied && <span className={styles.tooltip}>¡Copiado!</span>}
																	</div>
																)}
															</div>
														</Grid.Column>
														<Grid.Column className={styles.columnClass}>
															<div className={styles.perfilClass}>
																<Text className={styles.textClass}>
																	Perfil <span className={styles.required}>*</span>
																</Text>
																<Dropdown
																	placeholder="Seleccionar"
																	search
																	fluid
																	required
																	selection
																	disabled={modalOption === "Watch"}
																	options={perfilData}
																	name="perfil"
																	value={formData.perfil}
																	onChange={handlePerfilDropdown}
																	error={!isEmpty(errors.perfil) && { content: errors.perfil, pointing: "above" }}
																/>
																{errors.perfil && (
																	<div>
																		<Label basic color="red" pointing="above">
																			{errors.perfil}
																		</Label>
																	</div>
																)}
															</div>
														</Grid.Column>
													</Grid.Row>
													<Grid.Row className={styles.grid}>
														<Grid.Column className={styles.columnClass}>
															<Input
																size="mini"
																icon="user"
																required
																label="Nombre Completo"
																name="fullName"
																error={!isEmpty(errors.fullName) && { content: errors.fullName, pointing: "above" }}
																disabled={modalOption === "Watch"}
																value={formData.fullName}
																onChange={handlerInput}
															/>
														</Grid.Column>
														<Grid.Column className={styles.columnClass}>
															<Input
																size="mini"
																icon="user"
																required
																label="Nombre de usuario"
																name="nickName"
																error={!isEmpty(errors.nickName) && { content: errors.nickName, pointing: "above" }}
																disabled={modalOption === "Watch"}
																value={formData.nickName}
																onChange={handlerInput}
															/>
														</Grid.Column>
														<Grid.Column className={styles.columnClass}>
															<Input
																size="mini"
																icon="at"
																label="Correo"
																required
																name="email"
																disabled={modalOption === "Watch"}
																value={formData.email}
																onChange={handlerInput}
																error={
																	!isEmpty(errors.email) && {
																		content: errors.email,
																		pointing: "above",
																	}
																}
															/>
														</Grid.Column>
													</Grid.Row>
													<Grid.Row className={styles.grid}>
														<Grid.Column className={styles.columnClass}>
															<Input
																size="mini"
																icon="phone"
																label="Teléfono"
																required
																name="phone"
																value={phoneFormat(formData.phone)}
																disabled={modalOption === "Watch"}
																onChange={handlerInput}
																error={
																	!isEmpty(errors.phone) && {
																		content: errors.phone,
																		pointing: "above",
																	}
																}
															/>
														</Grid.Column>
														{modalOption === "Add" && (
															<Grid.Column className={styles.columnClass}>
																<Input
																	size="mini"
																	required
																	isPassword
																	label="Contraseña"
																	autoComplete="new-password"
																	error={
																		!isEmpty(errors.password) && {
																			content: errors.password,
																			pointing: "above",
																		}
																	}
																	name="password"
																	value={formData.password}
																	onChange={handlerInput}
																/>
															</Grid.Column>
														)}
														<Grid.Column className={styles.columnClass}>
															<Form.Field>
																<Text className={styles.textClass}>Default Menú:</Text>
																<Dropdown
																	placeholder="Seleccione una opción"
																	fluid
																	selection
																	name="defaultMenu"
																	value={formData.defaultMenu}
																	onChange={(e, { value }) => {
																		return setFormData((prev) => {
																			return {
																				...prev,
																				defaultMenu: value == null ? null : Number(value),
																			};
																		});
																	}}
																	options={menuOptions}
																	disabled={modalOption === "Watch" || !formData.checkMenus || formData.checkMenus.length === 0}
																/>
															</Form.Field>
														</Grid.Column>
													</Grid.Row>
												</Grid>
											</Form>
										</div>
									</Grid.Column>
								</Grid.Row>
							</Grid>
						)}
						<Grid columns={2} stackable className={styles.grid}>
							<Grid.Row className={styles.grid}>
								<Grid.Column width="10" className={`${styles.grid2} ${styles.columnClass}`}>
									{stateHeader === "basicInfo" && (
										<div className={styles.containerField}>
											<fieldset className={styles.fieldsetGroups}>
												<legend className={styles.legend}>
													<Header className={styles.titleBoxB} as="h3" icon="key">
														<Icon className={styles.icons} name="group" />
														Grupos <span className={styles.required}>*</span>
													</Header>
												</legend>

												<Form size="mini">
													<div className={styles.classCheck}>
														<Checkbox
															name="groupsAll"
															className={styles.checkBox}
															checked={groupsAll}
															onChange={() => checkAll("groupsfilters")}
														/>
														<Text className={styles.sectionTitleText}>Todos</Text>
													</div>

													<Dropdown
														placeholder="Grupos"
														fluid
														multiple
														search
														selection
														disabled={modalOption === "Watch"}
														options={groupData}
														name="userGroups"
														value={formData.userGroups}
														onChange={handleInputDropdown}
														error={
															!isEmpty(errors.userGroups) && {
																content: errors.userGroups,
																pointing: "above",
															}
														}
													/>
												</Form>
												{errors.userGroups && (
													<div>
														<Label basic color="red" pointing="above">
															{errors.userGroups}
														</Label>
													</div>
												)}
											</fieldset>
										</div>
									)}
									{stateHeader === "permissions" && (
										<fieldset className={styles.fieldsetPermissions}>
											<legend className={styles.legend}>
												<div className={styles.legendPermissionsContainer}>
													<Header className={styles.titleBoxB} as="h3" icon="key">
														<Icon className={styles.icons} name="key" />
														Permisos <span className={styles.required}>*</span>
													</Header>
													{!isEmpty(formData.role) && (
														<div className={styles.roleDisplay}>
															<Text className={styles.roleLabel}>Rol:</Text>
															<Text className={styles.roleValue}>{formData.role}</Text>
														</div>
													)}
												</div>
											</legend>

											<Form className={styles.PermissionContainer}>
												{/* <Form.Checkbox
													toggle
													label="Asignar Chat"
													disabled={modalOption === "Watch"}
													name="allowChatAssign"
													checked={get(formData, `permissions.allowChatAssign`, false)}
													onChange={onChangePermissions}
													width="8"
												/> */}
												<Form.Checkbox
													toggle
													label="Finalizar Chat"
													disabled={modalOption === "Watch"}
													name="allowEndChat"
													checked={get(formData, `permissions.allowEndChat`, false)}
													onChange={onChangePermissions}
													width="8"
												/>
												<Form.Checkbox
													toggle
													label="Liberar Chat"
													disabled={modalOption === "Watch"}
													name="allowFreeChat"
													checked={get(formData, `permissions.allowFreeChat`, false)}
													onChange={onChangePermissions}
													width="8"
												/>
												<Form.Checkbox
													toggle
													label="Iniciar Chat"
													disabled={modalOption === "Watch"}
													name="allowStartChat"
													checked={get(formData, `permissions.allowStartChat`, false)}
													onChange={onChangePermissions}
													width="8"
												/>
												<Form.Checkbox
													toggle
													label="Tomar Chat"
													disabled={modalOption === "Watch"}
													name="allowTakeChat"
													checked={get(formData, `permissions.allowTakeChat`, false)}
													onChange={onChangePermissions}
													width="8"
												/>
												<Form.Checkbox
													toggle
													label="Transferir Chat"
													disabled={modalOption === "Watch"}
													name="allowTransferChat"
													checked={get(formData, `permissions.allowTransferChat`, false)}
													onChange={onChangePermissions}
													width="8"
												/>
												<Form.Checkbox
													toggle
													label="Ver todos los chats"
													disabled={modalOption === "Watch"}
													name="allowViewAllChats"
													checked={get(formData, `permissions.allowViewAllChats`, false)}
													onChange={onChangePermissions}
													width="8"
												/>
												<Form.Checkbox
													toggle
													label="Quitar Chat"
													disabled={modalOption === "Watch"}
													name="allowRemoveChat"
													checked={get(formData, `permissions.allowRemoveChat`, false)}
													onChange={onChangePermissions}
													width="8"
												/>
												<Form.Checkbox
													toggle
													label="Finalizar sin Msj"
													disabled={modalOption === "Watch"}
													name="allowEndChatWithoutMessage"
													checked={get(formData, `permissions.allowEndChatWithoutMessage`, false)}
													onChange={onChangePermissions}
													width="8"
												/>
												<Form.Checkbox
													toggle
													label="Mostrar 'No Asigna Chat'"
													disabled={modalOption === "Watch"}
													name="noAssignState"
													checked={get(formData, `permissions.noAssignState`, false)}
													onChange={onChangePermissions}
													width="8"
												/>
												{!endChatNoResponse && (
													<Form.Checkbox
														toggle
														label="Finalizar Sin Entender"
														disabled={modalOption === "Watch"}
														name="endChatNoResponse"
														checked={get(formData, `permissions.endChatNoResponse`, false)}
														onChange={onChangePermissions}
														width="8"
													/>
												)}
												<Form.Checkbox
													toggle
													label="No Envia Plantilla"
													disabled={modalOption === "Watch"}
													name="noSendTemplate"
													checked={get(formData, `permissions.noSendTemplate`, false)}
													onChange={onChangePermissions}
													width="8"
												/>
												<Form.Checkbox
													toggle
													label="Transferir Múltiples Chats"
													disabled={modalOption === "Watch"}
													name="allowTransferMultipleChats"
													checked={get(formData, `permissions.allowTransferMultipleChats`, false)}
													onChange={onChangePermissions}
													width="8"
												/>
												<Form.Checkbox
													toggle
													label="Liberar Todas (Cerrar Sesión)"
													disabled={modalOption === "Watch"}
													name="allowFreeAllChats"
													checked={get(formData, `permissions.allowFreeAllChats`, false)}
													onChange={onChangePermissions}
													width="8"
												/>
												{sendFlowEnabled && (
													<>
														<Form.Checkbox
															toggle
															label="Enviar Flow"
															disabled={modalOption === "Watch"}
															name="allowSendFlow"
															checked={get(formData, `permissions.allowSendFlow`, false)}
															onChange={onChangePermissions}
															width="8"
														/>
														<Form.Checkbox
															toggle
															label="Configurar Flow"
															disabled={modalOption === "Watch"}
															name="allowConfigFlow"
															checked={get(formData, `permissions.allowConfigFlow`, false)}
															onChange={onChangePermissions}
															width="8"
														/>
													</>
												)}
											</Form>
										</fieldset>
									)}
								</Grid.Column>
								{stateHeader === "basicInfo" && (
									<Grid.Column width="6" className={`${styles.grid} ${styles.columnClass}`}>
										<fieldset className={styles.fieldsetMenu}>
											{errors.checkMenus && (
												<div>
													<Label basic color="red" pointing="above">
														{errors.checkMenus}
													</Label>
												</div>
											)}
											<legend className={styles.legend}>
												<Header className={styles.titleBoxB} as="h3" icon="sidebar">
													<Icon className={styles.icons} name="sidebar" />
													Menú <span className={styles.required}>*</span>
												</Header>
											</legend>

											<MenuSelect
												inValue={formData.checkMenus}
												menuData={menuData}
												disabled={modalOption === "Watch"}
												onValue={(value) => {
													handlerMenu(value);
												}}
											/>
										</fieldset>
									</Grid.Column>
								)}
							</Grid.Row>
						</Grid>
					</div>
				</div>
			</IKModal>
			{open && (
				<ConfirmModal
					buttonLabel="Salir"
					visible
					header="Confirmar Cerrar"
					content="Está seguro que desea salir del formulario"
					onConfirm={cancelModal}
					onDismiss={modalOpen}
				/>
			)}
			{showProfileConfirmModal && (
				<ConfirmModal
					visible
					icon="exchange"
					header="Cambiar Perfil"
					fullContent={`¿Desea aplicar los menú y permisos sugeridos del perfil"${get(
						pendingProfile,
						"name",
						""
					)}" o mantener la configuración actual del usuario?`}
					buttonLabel="Aplicar sugeridos"
					cancelLabel="Mantener actuales"
					extraButton={
						<Button className={styles.cancelProfileButton} onClick={handleCancelProfileChange}>
							Cancelar
						</Button>
					}
					onConfirm={handleApplyNewProfile}
					onDismiss={handleKeepCurrentProfile}
				/>
			)}
		</>
	);
};

MtnUserCrud.propTypes = {
	tableValue: PropTypes.object,
	onClose: PropTypes.func,
	dispatch: PropTypes.func,
	groups: PropTypes.array,
	apiData: PropTypes.func,
	userPermissions: PropTypes.object,
	groupsData: PropTypes.array,
	menuData: PropTypes.array,
	modalCrud: PropTypes.string,
	perfilesList: PropTypes.array,
	endChatNoResponse: PropTypes.bool,
	sendFlowEnabled: PropTypes.bool,
	userRole: PropTypes.string,
};
function mapStateToProps({ user, company }) {
	return {
		userRole: user.name,
		userPermissions: user.permissions,
		endChatNoResponse: company.settings.endChatNoResponse,
		sendFlowEnabled: company.settings.sendFlow,
	};
}
export default connect(mapStateToProps)(MtnUserCrud);
